import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
}), 'ReorderOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ReorderOutlined.js
// module id = 5739
// module chunks = 2